<template>
  <div
    class="smallVideo link"
    :class="{ loaded: !cover, cover: loaded }"
    v-if="!hidelaudatio"
  >
    <div
      class="videoInner"
      :style="{ paddingBottom: item.video_image.ratio + '%' }"
    >
      <video
        v-if="!cover"
        ref="vidpl"
        :poster="item.video_image.src"
        id="player"
        playsinline
        controls
        preload="metadata"
      >
        <source :lazysrc="item.video" :src="item.video" type="video/mp4" />
      </video>

      <div class="playHover" @click="playVideo" v-lazyload>
        <LazyImage
          :source="item.video_image.src"
          :blur="item.video_image.src_blur"
        />
        <div class="playButton"></div>
      </div>
    </div>
    <div
      v-if="item.video_credits && $route.params.filter !== 'videos'"
      class="caption"
      v-html="item.video_credits"
    ></div>
  </div>
</template>

<script>
import LazyImage from '@/components/LazyImage.vue';

export default {
  props: ['item', 'index', 'stop'],

  components: {
    LazyImage,
  },

  data() {
    return {
      cover: true,
      loaded: false,
    };
  },

  watch: {
    stop(val) {
      if (val !== this.index) {
        this.cover = true;
        this.loaded = false;
      }
    },
  },

  computed: {
    hidelaudatio() {
      let hL = this.$store.getters.hidelaudatio;
      let cY = this.item.year.title === this.$store.state.currentyear;

      if (hL === 1 && cY) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    playVideo() {
      this.cover = false;
      this.$nextTick(() => {
        let video = this.$refs.vidpl;
        this.$nextTick(() => {
          this.loaded = true;
          this.$emit('stopAll', this.index);
          video.play();
          video.addEventListener('loadedmetadata', () => {
            video.play();
          });
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

.smallVideo {
  width: 33.3333%;
  padding: 2rem 1rem 0;
  position: relative;
}

.videoInner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.loaded.smallVideo video {
  opacity: 1;
}

.smallVideo {
  video {
    opacity: 0;
    transition: opacity $ease ease 0.5s;
  }

  .playHover,
  video {
    position: absolute;
    left: 0;
    tab-size: 0;
    width: 100%;
    height: 100%;
  }

  .playHover {
    img {
      position: absolute;
      width: 102%;
      height: 102%;
      left: -1%;
      top: -1%;
    }
  }
}

.cover .playHover {
  opacity: 0;
  pointer-events: none;
}

.playHover {
  transition: opacity $ease ease;
  cursor: pointer;

  &:hover {
    .playButton {
      opacity: 0.5;
    }
  }
}

.playButton {
  opacity: 0;
  width: 0;
  height: 0;
  border-top: 2rem solid transparent;
  border-bottom: 2rem solid transparent;
  border-left: calc(2rem * 1.4) solid $maincolour;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.loaded .playButton {
  opacity: 1;
}

@media screen and (max-width: $breakPoint1) {
  .smallVideo {
    width: 100%;
  }
}
</style>
